import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home"),
  },
  {
    path: "/platform",
    name: "platform",
    component: () => import("../views/Platform"),
  },
  {
    path: "/team",
    name: "team",
    component: () => import("../views/Team"),
  },
  {
    path: "/plans",
    name: "plans",
    component: () => import("../views/Plans"),
  },
  {
    path: "/trends",
    name: "trends",
    component: () => import("../views/Trends"),
  },
  {
    path: "/trends/:id",
    name: "trends-post",
    component: () => import("../views/TrendsPost"),
  },
  {
    path: "/help",
    name: "help",
    component: () => import("../views/Help"),
  },
  {
    path: "/cliente/:form?",
    name: "client",
    component: () => import("../views/temporary/Client"),
  },
  {
    path: "/especialista/:form?",
    name: "specialist",
    component: () => import("../views/temporary/Specialist"),
  },
  {
    path: "/servicio/:id",
    name: "service",
    component: () => import("../views/Service.vue"),
  },
  // {
  //   path: '/subscribe',
  //   name: 'subscribe',
  //   component: () => import('../views/Subscribe')
  // },
  {
    name: "500",
    path: "/maintenance",
    component: () => import("@/views/errors/500"),
    meta: {
      metaTags: [
        {
          name: "robots",
          content: "noindex",
        },
      ],
    },
  },
  {
    name: "404",
    path: "*",
    component: () => import("@/views/errors/404"),
    meta: {
      metaTags: [
        {
          name: "robots",
          content: "noindex",
        },
      ],
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
